/* eslint-disable */
<template>
  <div>
  <!-- <div class="flex flex-col"> -->
    
    <!-- <nav class="w-screen fixed bg-opacity-90 bg-white p-4 lg:px-20 flex flex-row justify-evenly z-50"> -->
    <nav class="w-screen fixed bg-opacity-90 bg-white p-4 lg:px-20 flex flex-row justify-between items-center z-50">

      <div class="flex flex-row justify-between w-full items-center">


      <div class="h-full flex flex-col justify-center">
        <p class="tracking-widest font-semibold ">TRIPLE PALM</p>
        <p class="tracking-widest font-light">REHABILITATION AND RECOVERY CENTER</p>
      </div>
    

  
    
        <button role="menubar" class="md:hidden" @click="navToggle()">
        <img
          :src="navOpen ? require('@/assets/close.png') : require('@/assets/menu.png')"
          alt="menu icon"
          class="text-2xl w-[20px] h-[20px]"
        />
        </button>
      
      
    <!-- Toggler end -->

    <!-- Menu content start -->
    <div class="absolute left-0 right-0 translate-y-16 bg-opacity-90 bg-white md:bg-none md:bg-opacity-0 shadow hidden md:flex flex-col gap-4 items-center p-4 md:flex-row md:static md:shadow-none md:translate-y-0" role="menu" aria-expanded="false">
      <!-- Links start -->
      <a href="#" role="menuitem">
        <router-link to="/Home">
          <p class="mx-4">Home</p>
        </router-link>
        
      </a>

      
      <div class="flex flex-col menu">
        <a href="#"  @mouseover="showDropdown = true" @mouseleave="showDropdown = false">
              <p class="mx-4">Admission</p>
            </a>
        <div class="dropdown" v-show="this.showDropdown" @mouseover="showDropdown = true" @mouseleave="showDropdown = false">
            <ul>
              <li>
                <router-link to="/admissionSection">
                <a href="#">Admission Infor</a>
                </router-link>
              </li>
              <li>
                <router-link to="/bookSection">
                <a href="#">Book an appointment</a>
                </router-link>
              </li>
              <li>
                <router-link to="/costsSection">
                <a href="#">Cost and finances</a>
                </router-link>
              </li>
              
              
            </ul>
        </div>
      </div>
      

      <div class="flex flex-col menu2">
        <a href="#"  @mouseover="showDropdown2 = true" @mouseleave="showDropdown2 = false">
              <p class="mx-4">Resources</p>
            </a>
        <div class="dropdown2" v-show="this.showDropdown2" @mouseover="showDropdown2 = true" @mouseleave="showDropdown2 = false">
            <ul>
              <li>
                <router-link to="/EduSection">
                <a href="#">Alcoholism</a>
                </router-link>
              </li>
              <li>
                <router-link to="/recSection">
                <a href="#">Recovery process</a>
                </router-link>
              </li>
              
              <li>
                <router-link to="/stepSection">
                <a href="#">12 steps</a>
                </router-link>
              </li>
              <li>
                <router-link to="/homeCareSection">
                <a href="#">Home care</a>
                </router-link>
              </li>
              
            </ul>
        </div>
      </div>
      
      <button class="btn" role="menuitem" @click="scrollToBottom" >
        Contact us
      </button>
   

      
      <!-- Links end -->
    </div>
  </div>
  <div v-if="navOpen" class="absolute left-0 right-0 top-16 bg-opacity-90 bg-white flex flex-col items-center shadow md:hidden">
        <router-link to="/Home" @click="closeMenu"><p class="mx-4 p-2">Home</p></router-link>
        <router-link to="/admissionSection" @click="closeMenu"><p class="mx-4 p-2">Admission Info</p></router-link>
        <router-link to="/bookSection" @click="closeMenu"><p class="mx-4 p-2">Book an Appointment</p></router-link>
        <router-link to="/costsSection" @click="closeMenu"><p class="mx-4 p-2">Cost & Finances</p></router-link>
        <router-link to="/EduSection" @click="closeMenu"><p class="mx-4 p-2">Alcoholism</p></router-link>
        <router-link to="/recSection" @click="closeMenu"><p class="mx-4 p-2">Recovery Process</p></router-link>
        <router-link to="/stepSection" @click="closeMenu"><p class="mx-4 p-2">12 Steps</p></router-link>
        <router-link to="/homeCareSection" @click="closeMenu"><p class="mx-4 p-2">Home Care</p></router-link>
        <router-link to="/Home" @click="closeMenu"><button class="mx-4 p-2" @click="scrollToBottom">Contact Us</button></router-link>
      </div>
      
  
    
    <!-- Menu content end -->
  </nav>
  

  </div>
  
    <!-- Navbar start -->
    
    
    <!-- Navbar end -->
</template>

<script>

export default {
  data() {
    return {
      navOpen: false,
      showDropdown: false, 
      showDropdown2: false,// To control the visibility of the dropdown menu
    };
  },
    methods: {
    // Toogle navbar mode 
    navToggle() {
      this.navOpen = !this.navOpen;
    },
    closeMenu() {
      this.navOpen = false;
    },
    scrollToBottom() {
      window.scrollTo({
        top: document.body.scrollHeight,
        behavior: 'smooth', // Smooth scrolling
      });
    },
    }
}
</script>

<style>

.menu {
  position: relative;
  display: inline-block;
}


.dropdown {
  
  position: absolute;
  top: 100%; /* Positioned just below the menu item */
  left: 0;
  background-color: white;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  padding: 10px;
  
  min-width: 250px;
}

.dropdown ul {
  list-style-type: none;
  margin: 0;
  padding: 0;
}

.dropdown li {
  margin: 5px 0;
}

.dropdown a {
  text-decoration: none;
  color: black;
  display: block;
  padding: 5px 10px;
}

.dropdown a:hover {
  background-color: #f0f0f0; /* Hover effect on dropdown links */
}

.dropdown2 {
  /* display: ; Default state is hidden */
  position: absolute;
  top: 65%; /* Positioned just below the menu item */
  left: 50%;
  background-color: white;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  padding: 10px;
  min-width: 250px;
}

.dropdown2 ul {
  list-style-type: none;
  margin: 0;
  padding: 0;
}

.dropdown2 li {
  margin: 5px 0;
}

.dropdown2 a {
  text-decoration: none;
  color: black;
  display: block;
  padding: 5px 10px;
}

.dropdown2 a:hover {
  background-color: #f0f0f0; /* Hover effect on dropdown links */
}

</style>